import styled, {css} from "styled-components"
import Toggle from "react-toggle"

import {Label as TypographyLabel} from "../../../Typography"
import TinyLoader from "../../styled/TinyLoader"
import Label from "../../styled/Label"

export const StyledLoader = styled(TinyLoader)`
  margin-top: -2px;
`

export const StyledLabel = styled(Label)`
  margin-bottom: 0;
  margin-right: 7px;
  cursor: pointer;
  ${TypographyLabel}
`

// horrid styling but 3rd party
export const StyledToggle = styled(Toggle)`
  ${({togglecolor}) => css`
    .react-toggle-track {
      background-color: ${({theme}) => theme.colors.greys.light} !important;
    }
    &.react-toggle--checked .react-toggle-track {
      background-color: ${togglecolor} !important;
    }
    &.react-toggle--checked .react-toggle-thumb {
      border-color: ${togglecolor};
    }
    &.react-toggle--focus .react-toggle-thumb {
      box-shadow: none;
    }
  `}
`
